import Backbone from "backbone";
import Drop from "tether-drop";
import ReviewSubmitPopinView from "./ReviewSubmitPopinView";
import { pathname } from "../others/Configuration";
import { CONFLICT } from "../../api/HTTPStatus";
import $ from "jquery";
import _ from "underscore";
import SharedDispatcher from "../others/SharedDispatcher";
import { MagnificPopup } from "../../common/dynamic-imports/MagnificPopup";

import "component?js-PopupInline";
import "component?js-PopinKoboRedirect";
import getPopinContent from "../../article/views/utils/popins";


const popinsUrlNames = {
  fnacWarranty: 'fnac-warranty',
  moneyBackGuarantee: 'money-back-guarantee',
  tvInstallation: 'tv-installation',
  mobileProtection: 'mobile-protection',
  nomadeProtection: 'nomade-protection',
  freeStoreReturns: 'free-store-returns',
  afterSalesService: 'after-sales-service',
  shippingAndPayment: 'shipping-and-payment',
  expressPlus: 'express-plus',
  fnacPlus: 'fnac-plus',
  paymentOffer: 'payment-offer',
  paymentOfferMobile: 'payment-offer-mobile',
  installmentDrop: 'drop-view-oney',
  brisGlace: 'bris-glace'
};

export default Backbone.View.extend({

  events: {
    "click .js-FnacWarrantyPopin": "openFnacWarrantyPopin",
    "click .js-MoneyBackGuaranteePopin": "openMoneyBackGuaranteePopin",
    "click .js-FreeStoreReturnPopin": "openFreeStoreReturnPopin",
    "click .js-AfterSalesServicePopin": "openAfterSalesServicePopin",
    "click .js-ShippingAndPaymentPopin": "openShippingAndPaymentPopin",
    "click .js-SeeSummary": "seeSummary",
    "click .js-CloseSummary": "closeSummary",
    "click .js-NewReview": "loadProductReviewForm",
    "click .js-HelpfulReview": "openHelpfulReviewPopin",
    "click .js-PaymentOffer": "openPaymentOfferDetailsPopin",
    "click .js-BrisGlacePopin": "openBrisGlacePopin"
  },

  initialize: function (opts) {
    this.createInstallmentDrop = this.createInstallmentDrop.bind(this);
    this.installmentDropOpened = this.installmentDropOpened.bind(this);
    this.installmentDropClosed = this.installmentDropClosed.bind(this);

    var attr = this.$el.data();
    this.catalog = attr.catalog;
    this.prid = attr.prid;
    this.isOpen = false;
    this.magnificPopup = new MagnificPopup();
    this.createInstallmentDrop();
    // Event bus to load 3/4X drop element
    this.listenTo(SharedDispatcher, "installmentDrop:open", () => {
      this.createInstallmentDrop();
    });

    if (this.checkAutoDisplayReviewForm()) {
      this.loadProductReviewForm();
    }
  },

  checkAutoDisplayReviewForm: function () {
    var hash = window.location.hash;
    return hash.indexOf('newReview') !== -1;
  },

  /**
   * Permet de charger le contenu de la popin avis client.
   * Cet appel est effectué en ajax dés le chargement de la page afin de gérer le cas où un
   * utilisateur peut déja avoir posté un avis sur le produit. Dans ce cas, on ne lui affichera pas
   * la popin mais un message d'erreur.
   */
  loadProductReviewForm: function () {

    if (this.newReviewForm) {
      // Popin has already loaded
      this.displayPopin();
    } else {
      var url = [pathname, '/api/v1/nav/static?key=new-review'].join('');
      var data = { prid: this.prid, catalog: this.catalog };

      getPopinContent({ url: url }, data)
        .done(function (result) {

          this.newReviewForm = {
            htmlContent: result,
            prid: data.prid,
            catalog: data.catalog
          };

          this.displayPopin();

        }).bind(this)
        .error(function (jqXHR, textStatus, errorMsg) {
          if (jqXHR.status === CONFLICT) {
            this.displayConflictError(errorMsg);
          }
        }).bind(this);
    }
  },

  displayConflictError: function (error) {
    var element = '<span class="f-button-content f-button-content--error isActive">' + error + '</span>';
    var $newReviewLink = $(".js-NewReview");
    $newReviewLink.addClass("f-button--disabled f-button--disabledError");
    $newReviewLink.append(element);
  },

  seeSummary: function (e) {
    e.preventDefault();

    var $fnacOpinionContent = this.$('#fnacOpinion .whiteContent');
    var $publisherOpinionContent = this.$('#ficheResume .whiteContent');

    var text = '';
    if ($fnacOpinionContent.length) {
      text = $fnacOpinionContent.text();
    } else if ($publisherOpinionContent.length) {
      text = $publisherOpinionContent.text();
    }

    var txtBtn = this.$('.js-ProductSummary a').attr('data-close');
    if (text !== '') {
      this.$('.js-ProductSummary [itemprop="description"]').html(text);
      this.$('.js-ProductSummary a').removeClass("js-SeeSummary").addClass("js-CloseSummary");
      this.$('.js-CloseSummary').html(txtBtn);
    }
  },

  closeSummary: function (e) {
    e.preventDefault();
    var text = this.$el.find('.ProductSummary-description [itemprop="description"]').text();
    var textligth = text.substring(0, 154) + "...";
    var txtBtn = this.$el.find('.js-ProductSummary a').attr('data-open');
    if (text !== '') {
      this.$el.find('.js-ProductSummary [itemprop="description"]').html(textligth);
      this.$el.find('.js-ProductSummary a').removeClass("js-CloseSummary").addClass("js-SeeSummary");
      this.$el.find('.js-SeeSummary').html(txtBtn);
    }
  },

  openFnacWarrantyPopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.fnacWarranty }).done(function (res) {
      var delay = $(e.currentTarget).data('delay');
      var html = res.replace('{0}', delay);
      this.openPopin(html);
    }).bind(this);
  },

  openMoneyBackGuaranteePopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.moneyBackGuarantee }).done(this.openPopin);
  },

  openFreeStoreReturnPopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.freeStoreReturns }).done(this.openPopin);
  },

  openAfterSalesServicePopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.afterSalesService }).done(this.openPopin);
  },

  openShippingAndPaymentPopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.shippingAndPayment }).done(this.openPopin);
  },

  openBrisGlacePopin: function (e) {
    e.preventDefault();
    getPopinContent({ popinPageName: popinsUrlNames.brisGlace }).done(this.openPopin);
  },

  displayPopin: function (e) {
    if (typeof e !== 'undefined') { e.preventDefault(); }
    if (this.newReviewForm) {
      var popinData = { prid: this.newReviewForm.prid };
      this.openPopin(this.newReviewForm.htmlContent, {
        callbacks: {
          open: function () {
            popinData.el = this.content[0];
            new ReviewSubmitPopinView(popinData);
          }
        }
      });
    }
  },

  openPopin: function (data, opts) {
    var defaultOptions = {
      items: { src: data },
      type: 'inline'
    };
    _.extend(defaultOptions, opts);
    this.magnificPopup.open(defaultOptions);
  },

  createInstallmentDrop: function () {
    if ($('.js-Oney-installment-listoffer').length) {
      _.each($('.js-Oney-installment-listoffer'), el => {
        if ($(el).is(':visible')) {
          this.installmentDrop = new Drop({
            target: el,
            content: '<div class="drop-view-oney"></div>',
            classes: 'drop-theme-arrows',
            position: 'top center',
            openOn: 'hover'
          });

          this.installmentDrop.on('open', this.installmentDropOpened);
          this.installmentDrop.on('close', this.installmentDropClosed);
        }
      });
    }
  },

  installmentDropOpened: function () {
    if ($('.Oney-installment-listoffer').length) {
      var $element = $('.Oney-installment-listoffer').html();
      $('.drop-view-oney').html($element);
      $('.Oney-installment-listoffer').remove();
    }
    this.installmentDrop.tether.position();
  },

  installmentDropClosed: function () {
  }

});
